<aside class="menu-lateral">
  <div class="menu-lateral__buttons-container">
    <ng-container *ngIf="autorizacoes.visualizarDashboard">

      <div class="aba-menu">
        <button type="button" routerLink="dashboard" routerLinkActive="pagina-selecionada">
          <div>
            <img src="/assets/images/simbolos/dashboard.svg" alt="Dashboard">
            <span>Dashboard</span>
          </div>
        </button>
      </div>

      <!-- <div class="aba-menu" *ngIf="this.autorizacoes.listarContratos">
        <button type="button" routerLink="listagem-de-contratos" routerLinkActive="pagina-selecionada">
          <div>
            <img src="/assets/images/simbolos/contratos.svg" alt="Contratos">
            <span>Contratos</span>
          </div>
        </button>
      </div> -->

      <!-- <div class="aba-menu"
        *ngIf="this.autorizacoes.listarDemonstrativosFinanceiros || this.autorizacoes.listarBoletos">
        <button type="button" (click)="toggleCollapse('financeiro')" [attr.aria-expanded]="!isFinanceiroCollapsed"
          aria-controls="collapseExample">
          <div>
            <img src="/assets/images/simbolos/dinheiro.svg" alt="Financeiro">
            <span>Financeiro</span>
          </div>
          <img class="seta-collapse" [ngClass]="{'rotate': isFinanceiroCollapsed}"
            src="/assets/images/simbolos/setaBranca.svg" alt="Financeiro">
        </button>
        <div class="aba-submenu" #financeiroCollapse="ngbCollapse" [(ngbCollapse)]="isFinanceiroCollapsed">
          <button type="button" routerLink="demonstrativo-financeiro" routerLinkActive="pagina-selecionada"
            *ngIf="this.autorizacoes.listarDemonstrativosFinanceiros">
            <span>Faturas</span>
          </button>
          <button type="button" routerLink="boletos" routerLinkActive="pagina-selecionada"
            *ngIf="this.autorizacoes.listarBoletos">
            <span>Boletos</span>
          </button>
        </div>
      </div> -->

      <div class="aba-menu" *ngIf="this.autorizacoes.listarEquipamentos || this.autorizacoes.listarChamadosAndamento ||
         this.autorizacoes.listarChamadosFinalizados || this.autorizacoes.abrirChamadoEquipamento">
        <button type="button" (click)="toggleCollapse('servicos')" [attr.aria-expanded]="!isServicosCollapsed"
          aria-controls="collapseExample">
          <div>
            <img src="assets/images/simbolos/ferramenta.svg" alt="Serviços">
            <span>Serviços</span>
          </div>
          <img class="seta-collapse" [ngClass]="{'rotate': isServicosCollapsed}"
            src="/assets/images/simbolos/setaBranca.svg" alt="Serviços">
        </button>
        <div class="aba-submenu" #servicosCollapse="ngbCollapse" [(ngbCollapse)]="isServicosCollapsed">
          <button type="button" routerLink="equipamentos" routerLinkActive="pagina-selecionada"
            *ngIf="this.autorizacoes.listarEquipamentos">
            <span>Equipamentos</span>
          </button>
          <button type="button" *ngIf="autorizacoes.listarChamadosAndamento || autorizacoes.listarChamadosFinalizados"
            [routerLink]="autorizacoes.listarChamadosAndamento ? 'historico-chamados' : 'historico-chamados/finalizados'"
            routerLinkActive="pagina-selecionada">
            <span>Histórico de chamados</span>
          </button>
          <button type="button" routerLink="equipamento/abrir-chamado/1" routerLinkActive="pagina-selecionada">
            <span>Solicitar assistência técnica</span>
          </button>
        </div>
      </div>

      <div class="aba-menu"
        *ngIf="this.autorizacoes.abrirChamadoSuprimentos || this.autorizacoes.listarHistoricosPedidos">
        <button type="button" (click)="toggleCollapse('suprimentos')" [attr.aria-expanded]="!isSuprimentosCollapsed"
          aria-controls="collapseExample">
          <div>
            <img src="assets/images/simbolos/suprimentos.svg" alt="Suprimentos">
            <span>Suprimentos</span>
          </div>
          <img class="seta-collapse" [ngClass]="{'rotate': isSuprimentosCollapsed}"
            src="/assets/images/simbolos/setaBranca.svg" alt="Suprimentos">
        </button>
        <div class="aba-submenu" #suprimentosCollapse="ngbCollapse" [(ngbCollapse)]="isSuprimentosCollapsed">
          <button type="button" routerLink="novo-suprimento/abrir-chamado/{{environment.company}}/1"
            routerLinkActive="pagina-selecionada" *ngIf="this.autorizacoes.abrirChamadoSuprimentos">
            <span>Solicitar suprimentos</span>
          </button>
          <button type="button" routerLink="/suprimentos/historico-de-pedidos" routerLinkActive="pagina-selecionada"
            *ngIf="this.autorizacoes.listarHistoricosPedidos">
            <span>Histórico de pedidos</span>
          </button>
        </div>
      </div>

      <!-- <div class="aba-menu" *ngIf="this.autorizacoes.listarInventarios">
        <button type="button" routerLink="listagem-inventario" routerLinkActive="pagina-selecionada">
          <div>
            <img src="/assets/images/simbolos/inventory.svg" alt="Inventário">
            <span>Inventário</span>
          </div>
        </button>
      </div> -->

      <div *ngIf="autorizacoes.listarUsuarios || autorizacoes.listarPerfis" class="aba-menu">
        <button type="button"
          [routerLink]="autorizacoes.listarUsuarios ? '/gestao-de-acesso' : '/gestao-de-acesso/perfil'"
          routerLinkActive="pagina-selecionada">
          <div>
            <img src="/assets/images/simbolos/usuarios.svg" alt="Gestão de Acesso">
            <span>Gestão de Acesso</span>
          </div>
        </button>
      </div>

      <div class="aba-menu">
        <button type="button" routerLink="documentos" routerLinkActive="pagina-selecionada">
          <div>
            <img src="/assets/images/simbolos/contratos.svg" alt="Documentos">
            <span>Documentos</span>
          </div>
        </button>
      </div>

    </ng-container>
  </div>

  <div class="aba-menu">
    <button type="button" (click)="sair()">
      <div>
        <span>SAIR</span>
      </div>
    </button>
  </div>

</aside>